import { gql } from '@apollo/client';
import { createFragmentRegistry } from '@apollo/client/cache';

export const fragmentRegistry = createFragmentRegistry();

fragmentRegistry.register(gql`
  fragment activeSubscriptionInformationFragment on CompanyProductSubscription {
    id
    subscriptionStatus
    nextPaymentStatus
    nextPaymentChargeDate
    paymentService
    orderSource
    subscriptionSystemSource
    orderNumber
    creditPurchaseOrderSubscriptionDetail {
      creditPurchaseOrder {
        totalPayment
        paymentUrl
        paymentService
      }
    }
  }
`);

fragmentRegistry.register(gql`
  fragment subscriptionFreeTrialOfferFragment on CompanyProductSubscriptionFreeTrialOffer {
    id
    timePeriod
    timePeriodUnit
  }
`);

fragmentRegistry.register(gql`
  fragment verificationBenefitsFragment on VerificationBenefitOutput {
    activeJobCount
    verifiedBadge
    paidFeatures
  }
`);
fragmentRegistry.register(gql`
  fragment companyVerificationInfoFragment on CompanyVerificationInfo {
    isInitiated
    isRejected
    lastVerificationRequest {
      id
      createdAt
      approvedAt
      rejectionReasons
      rejectionReasonText
      company {
        id
        status
      }
      companyVerificationMethod {
        verificationMethod
        benefits {
          ...verificationBenefitsFragment
        }
      }
      document {
        ... on LegalDocument {
          verificationMethod
          companyNpwpDocument
          companyNpwpDocumentMetadata {
            source
            producer
            creator
            createdAt
            modifiedAt
            companyName
            npwpNumber
          }
          companyNpwpNumber
          companyNibNumber
          additionalDocuments
          acraBizFile
          acraBizFileMetadata {
            companyName
            uen
          }
          companyUniqueEntityNumber
          companyLegalDoc
          companyLegalNumber
        }
        ... on ProofOfOwnership {
          verificationMethod
          personalNpwpDocument
          personalNpwpNumber
          personalNibNumber
          ktpDoc
          ktpNumber
          businessLocationType
          businessImages
          additionalDocuments
        }
      }
    }
    tierUpgrade {
      isUpgradeInitiated
      isUpgradeRejected
      availableTierUpgrade {
        verificationMethod
        benefits {
          ...verificationBenefitsFragment
        }
      }
    }
  }
`);

fragmentRegistry.register(gql`
  fragment premiumPlanCustomisationsPricingInfoFragment on PremiumPlanCustomisationsPricingInfo {
    additionalJobSlot {
      value
      currency
      credits
      totalCredits
      amount
      pricingInfo {
        originalPrice
        savedAmount
        totalAmount
        pricePerTimePeriodUnit
        currency
      }
    }
  }
`);

fragmentRegistry.register(gql`
  fragment companyCreditInfoFragment on CompanyCreditInfoOutput {
    totalAmount
    nextExpiringCredit {
      amount
      expiryDateTime
      expiryWindow
      canShowExpiringNotification @client
    }
  }
`);

fragmentRegistry.register(gql`
  fragment hierarchicalLocationFragment on HierarchicalLocation {
    id
    name
    formattedName
    level
  }
`);
